export default "__VITE_ASSET__Cutciv0C__"